import {useAuth} from '@apps-common/auth-react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {Checkbox, FormControlLabel, Typography} from '@mui/material';
import {SimpleTreeView, TreeItem as MUITreeItem} from '@mui/x-tree-view';
import PropTypes from 'prop-types';
import React from 'react';

import {PERMISSIONS_FILTERS} from '@app/constants/filters';
import useOrgParams from '@app/hooks/useOrgParams';

const TreeItem = props => (
  <MUITreeItem
    sx={{
      '& .MuiTreeItem-content': {
        padding: 0,
        '&:hover, &.Mui-selected, &.Mui-focused, &.Mui-selected:hover, &.Mui-focused:hover, &.Mui-selected.Mui-focused':
          {
            backgroundColor: 'transparent',
          },
      },
    }}
    {...props}
  />
);

const PermissionsFilter = ({checkedFilters, onChange}) => {
  const {user} = useAuth();
  const {orgId} = useOrgParams();

  return (
    <SimpleTreeView
      defaultExpandedItems={['Permissions']}
      slots={{expandIcon: ArrowRightIcon, collapseIcon: ArrowDropDownIcon}}
    >
      <TreeItem
        itemId="Permissions"
        label={<Typography variant="overline">Permissions</Typography>}
      >
        <TreeItem
          itemId="Created by me"
          label={
            <FormControlLabel
              disabled={orgId && user?.claims.organization_id !== Number(orgId)}
              control={
                <Checkbox color="primary" name={PERMISSIONS_FILTERS.OWNED} />
              }
              checked={!!checkedFilters[PERMISSIONS_FILTERS.OWNED]}
              label="Created by me"
              onChange={e => onChange(e)}
            />
          }
        />
        <TreeItem
          itemId="Shared with organization"
          label={
            <FormControlLabel
              disabled={orgId && user?.claims.organization_id !== Number(orgId)}
              control={
                <Checkbox color="primary" name={PERMISSIONS_FILTERS.SHARED} />
              }
              checked={!!checkedFilters[PERMISSIONS_FILTERS.SHARED]}
              label="Shared with organization"
              onChange={e => onChange(e)}
            />
          }
        />
      </TreeItem>
    </SimpleTreeView>
  );
};

PermissionsFilter.propTypes = {
  checkedFilters: PropTypes.object,
  onChange: PropTypes.func,
};

export default PermissionsFilter;
